"use client"

import { createPortal } from "react-dom"
import { Cursor02Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"

interface RemoteCursorProps {
  x: number
  y: number
  name: string
}

export function RemoteCursor({ x, y, name }: RemoteCursorProps) {
  return createPortal(
    <div
      data-meridial-ui
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        transform: `translate(${x}px, ${y}px)`,
        transition: "transform 50ms linear",
        zIndex: 999999,
        pointerEvents: "none",
      }}
    >
      <HugeiconsIcon
        icon={Cursor02Icon}
        strokeWidth={2}
        size={24}
        className="fill-primary/60 text-primary"
      />
      <span
        data-meridial-ui
        className="ml-3 -mt-1 inline-block whitespace-nowrap rounded bg-primary px-1.5 py-0.5 text-[10px] font-medium text-primary-foreground"
      >
        {name}
      </span>
    </div>,
    document.body
  )
}
